export const DocumentUploadIcon = () => (
	<svg
		width="76"
		height="66"
		viewBox="0 0 76 66"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0 33C0 14.7746 14.7746 0 33 0H42.4917C60.7171 0 75.4916 14.7746 75.4916 33C75.4916 51.2254 60.717 66 42.4916 66H33C14.7746 66 0 51.2254 0 33Z"
			fill="#EFF0F8"
		/>
		<g clipPath="url(#clip0_4_5148)">
			<path
				d="M48.3125 28.9168C46.8958 21.7293 40.5833 16.3335 33 16.3335C26.9792 16.3335 21.75 19.7502 19.1458 24.7502C12.875 25.4168 8 30.7293 8 37.1668C8 44.0627 13.6042 49.6668 20.5 49.6668H47.5833C53.3333 49.6668 58 45.0002 58 39.2502C58 33.7502 53.7292 29.2918 48.3125 28.9168ZM47.5833 45.5002H20.5C15.8958 45.5002 12.1667 41.771 12.1667 37.1668C12.1667 32.896 15.3542 29.3335 19.5833 28.896L21.8125 28.6668L22.8542 26.6877C24.8333 22.8752 28.7083 20.5002 33 20.5002C38.4583 20.5002 43.1667 24.3752 44.2292 29.7293L44.8542 32.8543L48.0417 33.0835C51.2917 33.2918 53.8333 36.021 53.8333 39.2502C53.8333 42.6877 51.0208 45.5002 47.5833 45.5002ZM24.6667 35.0835H29.9792V41.3335H36.0208V35.0835H41.3333L33 26.7502L24.6667 35.0835Z"
				fill="#4B50BD"
			/>
		</g>
		<defs>
			<clipPath id="clip0_4_5148">
				<rect width="50" height="50" fill="white" transform="translate(8 8)" />
			</clipPath>
		</defs>
	</svg>
)
